module.exports = __webpack_public_path__ + "static/media/statistics.b0bdce02.png";